export const HOME = {
  emergentLink: "home-emergent-link",
  loginButton: "header-login-button",
  ctaLogin: "home-cta-login-button",
};

export const DIAGNOSTIC = {
  page: "google-diagnostic-page",
  testButton: "google-diagnostic-test-button",
  serviceAccountEmail: "google-diagnostic-service-account-email",
  sheetsConnection: "google-diagnostic-sheets-connection",
  sheetsFileAccessible: "google-diagnostic-sheets-file-accessible",
  sheetsTabsCount: "google-diagnostic-sheets-tabs-count",
  sheetsTabItem: "google-diagnostic-sheets-tab-item",
  sheetsError: "google-diagnostic-sheets-error",
  driveConnection: "google-diagnostic-drive-connection",
  driveFolderAccessible: "google-diagnostic-drive-folder-accessible",
  driveFolderCreation: "google-diagnostic-drive-folder-creation",
  driveError: "google-diagnostic-drive-error",
};
